function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import Cookies from "js-cookie";
// @ts-ignore
import jwt_decode from "jwt-decode";
var CLIENT_SESSION_COOKIE_NAME = "CLIENT-TOKEN";
var CLIENT_SESSION_QUERY_NAME = "session";
/**
 * Synchronizes claims from session token to Kaggle.Current global.
 * For cross-compatibility with Kaggle.Web FE code.
 */ export var synchronizeGlobals = function(claims) {
    var current = {
        isAnonymous: claims.anon || false
    };
    if (claims.anon !== true) {
        current.userId = claims.uid;
        current.userProfileUrl = claims.profileUrl;
        current.userDisplayNameEscaped = claims.displayName;
        current.userThumbnailUrl = claims.thumbnailUrl;
        current.userEmail = claims.email;
        current.userIsPhoneVerified = claims.verified;
        current.userName = claims.sub;
        current.tier = claims.tier;
    }
    if (claims.admin) {
        current.isAdmin = claims.admin;
        current.buildHash = claims.bld;
    }
    window.Kaggle = _objectSpread({}, window.Kaggle, {
        Current: current
    });
};
/** Gets the JWT base64 encoded client session token from cookie. */ export var getSessionTokenFromCookie = function() {
    var token = Cookies.get(CLIENT_SESSION_COOKIE_NAME);
    if (!token) {
        return null;
    }
    return token;
};
/**
 * Gets the JWT base64 encoded client session token from query string.
 *
 * This is used as a fallback to retrieve feature flags within iframes.
 */ var getSessionTokenFromQuery = function() {
    var token = new URLSearchParams(window.location.search).get(CLIENT_SESSION_QUERY_NAME);
    if (!token) {
        return null;
    }
    return token;
};
/**
 * Gets session claims from the JWT cookie and decodes them.
 * @param token Optionally override the token to be decoded (for unit testing).
 */ export var getSessionClaims = function() {
    var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getSessionTokenFromCookie() || getSessionTokenFromQuery();
    if (!token) {
        return null;
    }
    var claims = jwt_decode(token);
    if (!claims) {
        throw new Error("Claims could not be decoded.");
    }
    return claims;
};
